/**
 * Fix for IE select menus getting stuck when their underlying list changes.
 * Original code: http://kkurni.blogspot.com.au/2013/10/angularjs-ng-option-with-ie8.html
 *
 * Set the `ie-select-fix` attribute to the model expression that should trigger the list to re-render.
 *
 * @example <select ng-model="modelValue" ie-select-fix="itemList" ng-options="item.label for item in itemList">
 */
var module = angular.module('octopusApp.shared');

module.directive('ieSelectFix', ['$document',
  function($document) {

    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attributes) {
        var ua = window.navigator.userAgent;
        var isIE = ua.indexOf('Trident') !== -1 || ua.indexOf('Edge') !== -1;
        if (!isIE) {
          return;
        }

        var control = element[0];
        scope.$watch(attributes.ieSelectFix, function() {

          setTimeout(function() {
            //this will add and remove an option to trigger the rendering in IE8
            var option = document.createElement("option");
            control.add(option, null);
            control.remove(control.options.length - 1);
          }, 0);

        });
      }
    };
  }
]);


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/ie_select_fix.js
// module id = 592
// module chunks = 1